import { ActionCreators as ActionCreatorsMain, IGpsItemsResponse, IGpsItemsCentralRecordsResponse, IGpsCountsResponse } from './actions';
import { ActionCreators as GpsDeviceActionCreators, IGpsDeviceListResponse, IGpsLookupDataResponse, IAddGpsDeviceResponse, IVerifyGpsNumberResponse } from './actions-gps-device';

export const ActionCreators = {
    ...ActionCreatorsMain,
    ...GpsDeviceActionCreators
};

export {
    IGpsItemsResponse, IGpsCountsResponse, IGpsItemsCentralRecordsResponse,
    IGpsDeviceListResponse, IGpsLookupDataResponse, IAddGpsDeviceResponse, IVerifyGpsNumberResponse
};
